import AppRouter from "app-router/app-router";

export default AppRouter
